import clsx from 'clsx'

import { getValidIcon } from 'shared/lib/validateIcon'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  icon: AllIcons
  text: string
}

export const SearchResultCardParams = ({ icon, text }: Props) => {
  const iconToShow = getValidIcon(icon)

  return (
    <div className={s.paramsItem}>
      <AppIcon
        id={iconToShow}
        width={12}
        height={12}
        className={s.paramsIcon}
      />
      <p className={clsx('medium-12', s.paramsText)}>{text}</p>
    </div>
  )
}
